import React, { Component } from 'react';
import {
  Grid,
} from '@material-ui/core';
import styled from 'styled-components';
import _ from 'lodash';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {
  BoldLabel,
  AlignedGrid, QuoteComparisonExpansionPanel, createLoanGridElements, createLoanGridLabel,
  RightAlignedDiv,
  createLoanGridElementsWithRenderer,QuoteComparisonExpansionSummary,QuoteComparisonExpansionPanelDetails,
  createMultiLineStringLoanGridElements
} from './QuoteComparisonGridElements';
import numberFormatter from 'utils/numberFormatter';

const PaddedGrid = styled(Grid)`
  &&{
    display:flex;
    flex-direction:column;    
    justify-content:center;
  }  
`
const Spacer = styled.div`
  width:100%;
  height:24px;
`
class RateType extends Component {
  state = {
    expanded:true
  }

  handleChange = (event, expanded) => {
    this.setState({
      expanded: expanded
    });
  }
  renderBaseRate = (loan) => {
    let indexName = loan['indexName'];
    let currentRate = loan.baseRate;
    let renderedIndexName = indexName ? (<div>{indexName}</div>) : (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);    
    let renderedCurrentRate = (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>);
    if(currentRate)
      renderedCurrentRate = numberFormatter.formatRate(currentRate, 2);
    return (
      <div>
        {renderedIndexName}
        {renderedCurrentRate}
      </div>
    )
  }
  renderRate = (property) => {
    return (loan) => {
      let value = loan[property];
      if(!value && value !== 0)
        return (<RightAlignedDiv>{'\u2014'}</RightAlignedDiv>)
      return (<RightAlignedDiv>{numberFormatter.formatRate(loan[property], 2, '\u2014')}</RightAlignedDiv>)
    }
  }
  createBaseRateLabel = (label) => {
    return (<PaddedGrid item xs={2}><BoldLabel>{label}</BoldLabel><Spacer/></PaddedGrid>);
  }
  render() {
    const { loans,isCombined } = this.props;
    const { expanded } = this.state;

    return (
      <QuoteComparisonExpansionPanel onChange={this.handleChange} defaultExpanded>
        <QuoteComparisonExpansionSummary expandIcon={<ExpandMoreIcon />}>
          <Grid container direction="row" alignItems="stretch">
            {createLoanGridLabel("Rate Type")}
            {expanded && createLoanGridElements(loans, 'rateTypeRefName', '\u2014',isCombined)}
          </Grid>
        </QuoteComparisonExpansionSummary>
        <QuoteComparisonExpansionPanelDetails>
          <AlignedGrid container direction="row" justify="flex-start" alignItems="stretch">
            {this.createBaseRateLabel("Base Rate")}            
            {createLoanGridElementsWithRenderer(loans, this.renderBaseRate, '\u2014', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Spread")}
            {createLoanGridElementsWithRenderer(loans, this.renderRate('loanSpread'), '\u2014', isCombined)}
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Index Floor")}
            {
            !isCombined ? createLoanGridElementsWithRenderer(loans, this.renderRate('indexFloor'), '\u2014', isCombined) : createMultiLineStringLoanGridElements(loans, 'indexFloorString', '\u2014',isCombined)
            }
            <Grid item xs={12}></Grid>
            {createLoanGridLabel("Current Rate")}
            {createLoanGridElementsWithRenderer(loans, this.renderRate('currentRate'),'\u2014', isCombined)}
          </AlignedGrid>
        </QuoteComparisonExpansionPanelDetails>
      </QuoteComparisonExpansionPanel>
    )
  }
}

export default RateType;